import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Konut",
    redirect: "/bilgiler",
  },
  {
    path: "/bilgiler",
    name: "Bilgiler",
    component: () => import("@/templates/Bilgiler.vue"),
    beforeEnter: (to, from, next) => {
      window.setPageTitle("AXA Dijital Sağlık Sigortası | AXA Sigorta");
      next();
    },
  },
  {
    path: "/sms",
    name: "Sms",
    component: () => import("@/templates/Sms.vue"),
    beforeEnter: (to, from, next) => {
      window.setPageTitle("AXA Dijital Sağlık Sigortası | AXA Sigorta");
      next();
    },
  },
  {
    path: "/talebiniz-alinmistir",
    name: "TalebinizAlinmistir",
    component: () => import("@/templates/TalebinizAlinmistir.vue"),
    beforeEnter: (to, from, next) => {
      window.setPageTitle("AXA Dijital Sağlık Sigortası | AXA Sigorta");
      next();
    },
  },
  /* {
        path: "*",
        name: 'NotFound',
        redirect: '/',
    }, */
];
// TODO TAHA DEGISTI
const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes,
});

export default router;
